import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BENEFICIARIES, DATA_UPDATE, HOME_URL, ROUTING_TRAMITE_PENSION, URL_CAMBIO_AFP_CAPITAL, URL_CONTACTO_TRAMITE_PENSION, VIDEO_ATENCION } from "@constants/url.constant";
import { openClaraChatLauncher } from "@common/utils/open-clara-chat.util";
import {
  SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES,
  TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS,
} from "@shared/common/constants/tramite-pension-constant";
import { TramitePensionService } from "../../services/tramite-pension.service";

@Component({
  selector: "app-request-error",
  templateUrl: "./request-error.component.html",
  styleUrls: ["./request-error.component.scss"],
  standalone: false
})
export class RequestErrorComponent implements OnInit {
  error: any;

  constructor(private readonly location: Location, readonly router: Router, private readonly activatedRoute: ActivatedRoute, private readonly errorStateService: TramitePensionService
  ) {

  }


  ngOnInit(): void {
    this.getError();
  }

  ionViewWillEnter() {
    this.getError();
  }

  private getError() {
    this.error = this.errorStateService.getError();

    if (!this.error) {
      this.router.navigate(['/pensions/tramite-pensiones']);
    }

  }

  goBack() {
    this.location.back();
  }

  /**
   * Contador oculto: reintentos restantes antes de forzar redirección a inicio de app.
   */
  private reintentosErrorGeneralInicioRestantes(): number {
    const raw = sessionStorage.getItem(
      SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES
    );
    if (raw === null) {
      return TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS;
    }
    const n = Number.parseInt(raw, 10);
    return Number.isNaN(n) ? TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS : n;
  }

  goToClick(method: string | undefined) {
    if (!method) {
      return;
    }
    if (method === "goToVideoAtencion") {
      this.router.navigate(["/", VIDEO_ATENCION]);
    }
    else if (method === "goToHome") {
      this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}`], {
        relativeTo: this.activatedRoute,
      });
    }
    else if (method === "goToBeneficiario") {
      this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
    }
    else if (method === "goToSolicitudContacto") {
      this.router.navigate([URL_CONTACTO_TRAMITE_PENSION]);
    }
    else if (method === "goToClara") {
      openClaraChatLauncher();
    }
    else if (method === "goToTramitePensionInicio") {
      if (this.error?.useGeneralErrorLayout) {
        const remaining = this.reintentosErrorGeneralInicioRestantes();
        if (remaining <= 0) {
          sessionStorage.removeItem(
            SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES
          );
          this.errorStateService.clearError();
          this.router.navigate(["/", HOME_URL]);
          return;
        }
        sessionStorage.setItem(
          SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES,
          String(remaining - 1)
        );
      }
      this.errorStateService.clearError();
      this.router.navigate([`/${ROUTING_TRAMITE_PENSION.BASE_URL}`], {
        relativeTo: this.activatedRoute,
      });
    }
    else if (method === "goToAppHome") {
      sessionStorage.removeItem(
        SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES
      );
      this.errorStateService.clearError();
      this.router.navigate(["/", HOME_URL]);
    }
    else if (method === "goToCambiateAfpCapital") {
      this.errorStateService.clearError();
      globalThis.open(URL_CAMBIO_AFP_CAPITAL, "_blank", "noopener,noreferrer");
    }
  }
}
